/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
import { ComponentPositionContext } from "./component-position.context";
import { InvalidContext } from "cms/common/errors/invalid-context.error";

/**
 * Retrieves the entire ComponentPositionContext.
 */
export function useComponentPositionContext () {
    const context = useContext(ComponentPositionContext);

    if (!context) {
        throw new InvalidContext("ComponentPositionContext", "ComponentPositionProvider");
    }

    return context;
}
